export default __webpack_public_path__ + "static/media/3.302ed4bb.png";